export interface CheckboxProps {
  disabled?: boolean;
  defaultChecked?: boolean;
  id: string;
  label: string;
  name: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
}

const Checkbox = (props: CheckboxProps) => (
  <div className="flex w-full gap-2">
    <input
      id={props.id}
      className="disabled:border-steel-400 disabled:bg-steel-400 peer relative mt-1 h-6 w-6 shrink-0 appearance-none rounded-xs border-2 border-blue-200 bg-white checked:border-0 checked:bg-blue-500 focus:ring-1 focus:ring-blue-100 focus:ring-offset-0 focus:outline-hidden"
      type="checkbox"
      name={props.name}
      checked={props.checked}
      disabled={props.disabled}
      onChange={props.onChange}
    />
    <svg
      className="pointer-events-none absolute mt-1 hidden h-6 w-6 stroke-white outline-hidden peer-checked:block"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
    <label htmlFor={props.id} className="text-xl">
      {props.label}
    </label>
  </div>
);

export default Checkbox;
